import { type Facility } from '@reliance/types/models/Facility';
import { store } from '../store/store';

export const getConfigurationValue = (
  key: string,
  facility?: Facility,
): string | null => {
  if (facility && !Array.isArray(facility.configurations)) {
    return null;
  }
  const matches = (
    facility ?? store.getState().common.facility
  )?.configurations?.filter((c) => c.key.toLowerCase() == key.toLowerCase());
  if (matches && matches?.length > 0) {
    return matches[0].value;
  }
  return null;
};
